<script>
  let menuVisible;
  $: console.log(menuVisible);
</script>

<header class="site-header headroom headroom--top headroom--not-bottom">
  <div class="branding-bar">
    <div class="container">
      <div class="uchicago-logo">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="17">
          <path
            fill="#fff"
            d="M2.711 2.986c-.02 0-1.43.872-2.34.452.676-.368 2.802-1.684
            3.448-2.1.153.032.406.074.591.025.186-.049.303-.189.351-.222-.246.014-1.243.074-.83-.643.16.643
            1.31.052 1.722-.041 1.15-.26 1.141.94 1.043
            1.436-.037.184.352.316.543.289-.33.794-.771.073-.987.3-.1.104-.3.275-.374.571-.083.351-.038.485-.038.485.018.15.059.296.12.434.202.503.965-.072
            1.338.073.187.073.312.238.495.205.053-.043.029-.244.022-.318-.02-.17-.342-.194-.493-.423-.131-.203.15-.816.302-.993.035.22.143.422.298.585.245.244.377.275.69.482.145.093.295.216.324.435.092.3-.425.906-.083
            1.393-.256.245-.6 1.306-.065 1.847-.091.245-.21.808.266
            1.137-.16.333-.093.304.041.718-.296 0-.324-1.206-1.894-1.178-.036
            0-.043.18 0 .272.161.335.466.26.405
            1.118-.02.294-.167.033-.26-.048-.215-.185-.38-.21-.474-.816-.72.552-.669
            1.097-.656 1.426 0 0-.108-.29-.287-.724 0 0 .764-.918.905-1.112
            1.087-1.497.302-1.012-.287-.26-.384.5-.808.949-.808.949a1.07 1.07 0
            0 0-.15-.31c.273-.297.529-.61.766-.935
            1.014-1.543.042-.735-.521-.02-.256.32-.483.611-.483.611a2.141 2.141
            0 0 0-.32-.222c-.02.362-.139.269-.113.638-.27.334-.568.643-.892.927
            0 0-.073-.653-.054-.677.145-.173.7-.778.831-.947
            1.32-1.708.537-1.306-.09-.57-.418.481-.83 1.099-.836 1.084a.572.572
            0 0
            0-.198-.241s.576-.86.768-1.17c.754-1.26.027-.857-.442-.156-.334.511-.607
            1.128-.617 1.122-.036-.018-.074-.037-.113-.037 0 0
            .154-.645.229-1.035.111-.547-.24-.432-.463.125-.091.23-.114.548-.15.91-.108.013-.35.182-.35.182.063.326.133.15.234.396.157.386-.223.917.127
            1.369.134.173.216.192.186.306a.66.66 0 0
            0-.56.279c-.265-1.174-.335-1.912-.192-3.072.035-.285.18-.642.235-.918.047-.245.01-.424-.029-.431-.025-.005-.195.21-.39.652-.423.973-1.04
            2.684-1.248 3.11-.533-.174.331-2.911
            1.421-4.228.044-.177-.084-.227-.243-.082-.212.195-.502.653-.734.839-.37.308-.836.71-1.348.571.655-.677
            2.158-1.944
            2.325-2.261.053-.102-.08-.103-.329.033-.414.232-1.16.668-1.927.41.795-.418
            2.651-1.343 2.659-1.99zm2.23
            6.057c-.052.298-.027.406.06.697.139.442.083.309-.108.157-.15-.163-.24-.21-.312-.401-.018-.137.034-.162.36-.453zm3.193-7.806c-.012.841
            1.087.264 1.664.531a.603.603 0 0 1
            .291.306c-.617-.418-1.755.43-2.17-.252-.179-.3.215-.585.215-.585zm3.831-.982a.274.274
            0 0 1-.198.32.53.53 0 0 0 .633-.272c.145.59-.463.622-.652.662 0 0
            .308.083.324.278.035.499.368.456.439.417-.012.06-.113.361-.482.09-.063.059.1.153.133.4.042.312.031.602.4.793-.225.176-.493-.282-.515-.228-.023.058.314.23-.064
            1.095-.169-.097-.073-.072-.272-.314-.152-.12-.275-.133-.15.071.222.271.335.876.263
            1.042-.183-.081-.136-.22-.35-.414-.02.081.004.507.227.706.384.34.58.735.585.812.03.308-.056.597-.095.994a.386.386
            0 0 1-.29-.222c-.05-.095-.134-.262-.153-.25a.326.326 0 0
            0-.05.183c.016.11.05.213.098.315.064.13.238.282.369.401.167.48.092.665.046.682-.045.02-.142-.245-.238-.356-.037-.042-.313.015-.294.043.034.055.119.141.167.213.076.09.137.195.183.307.047.152.078.308.097.466.031.514-.15.786-.236
            1.036-.102-.387-.154-.678-.277-1.118a1.724 1.724 0 0
            0-.423.394c-.06.092-.109.156-.18.27a.679.679 0 0 1-.084.123 3.178
            3.178 0 0 0-.02-.393c-.078-.574-.31-1.373-.496-1.595a15.3 15.3 0 0
            0-.614 1.575c-.13.437-.238.94-.176 1.415.027.216.086.427.176.627a2.6
            2.6 0 0
            1-.37-.705c-.251-.826-.105-1.775.3-1.938.045-.113-.044-.507-.15-.44a.71.71
            0 0
            0-.24.352c-.388-.326-.203-.48-.11-.595.094-.115.204-.182.252-.263.25-.418-.056-.492-.077-.482a.523.523
            0 0
            1-.299.325c-.286-.48-.25-1.039.245-1.599.084-.1.264-.182.36-.282.017-.157-.157-.22-.299-.117a.414.414
            0 0
            1-.246.105c-.052-.474.046-1.303.948-1.333-.172-.05-.264-.081-.306-.22.273-.04
            1.13-.104.989-.764-.084.082-.108.198-.335.327-.15.089-.312.097-.398-.032.397-.13.266-.602-.25-.462-.16.042-.392-.12-.404-.3.116.113.354.029.485-.057.586-.37.94.164
            1.019.282.023 0
            .261-.536-.567-.68-.07-.19-.258-.522-.821-.48-.186-.64-.75-.327-.728-.036-.59-.424-.014-.963.225-1.047
            0 0
            .013.26.132.387.09.075.212.092.322.054.051-.018.057-.132.014-.22-.044-.079-.154-.2-.157-.27l.029-.017c.269-.15.262.192.4.065.061-.225.325-.35.541-.374.61-.081
            1.083.571 1.666.245zm2.637.37c.585-.196 1.81-.098
            2.34.125.242.094.505.111.759.06 0
            .122-.15.178-.239.202-.132.041-.469.082-.459.175.007.056.352.082.471.096.314.027.473.032.808.174.247.13.474.295.671.49a2.463
            2.463 0 0 0-.633-.186.808.808 0 0
            0-.342.01s.344.12.407.149c.3.18.563.414.773.691l1.18
            1.17c-.05.06-.405.017-1.474-.912a10.296 10.296 0 0
            1-.35-.312c-.052.047-.012.192.18.398.502.532 1.665 1.506 2.208
            2.54-.065.045-.903-.334-1.242-.672-.521-.53-1.222-1.827-1.468-1.63-.009
            0-.008.143.11.334.312.505 1.02 1.484 1.386 2.153.255.469.465
            1.135.482 1.638.089 2.484-.301 2.293-.301
            2.293-.598-1.959-.874-4.23-1.743-5.278-.127-.153-.167.039-.018.44.25.696.836
            2.029.875
            3.318-.226.074-.824.284-.836.367.012-.18.012-.36-.011-.54a6.326
            6.326 0 0 0-.595-2.193c-.105-.245-.222-.141-.2.152.035.458.235
            1.25.251 1.55 0 .021-2.308-2.632-.904-.367.368.584 1.032 1.114 1.037
            1.124.025.256 0
            .293-.08.513-.063.049-.684-.577-1.223-1.19-.68-.774-1.523-1.186-.377.33.244.33
            1.42 1.31 1.41
            1.326-.07.169-.098.293-.274.482-.03.038-.728-.533-.733-.566-.041-.31.008-.538-.39-.317
            0
            0-.305-.344-.573-.592-.35-.327-.836-.485-.405.163.173.271.384.518.625.734
            0
            0-.124.077-.199.402-.015.064-.32-.216-.575-.456-.256-.24-.518-.269-.27.205.163.3.736.63.73.653a3.503
            3.503 0 0 1-.182.51c-.08.154-1.18 1.012-1.185
            1.017.002-.004.217-.684.687-1.018.268-.192.197-.17.375-.278
            0-.101-.03-.245-.16-.29-.161-.056-.686.037-.686.037.05-.256-.071-.927-.069-1.53-.197.015-.706.261-.79.43-.061
            1.007-.232.587-.44
            1.311-.228-.303.123-.561-.094-.845-.313-.391-.235-.534-.281-1.01.072-.04.29-.368.006-1.078-.024-.558.092-.95.1-1.3.008-.35-.092-.657-.548-1.047.076-.024.059-.606.059-.607.664.35.475-.381.736-.529.422-.236.34-.48.154-.784
            1.188.326-.053 1.119.484
            1.142.39.012.649-.081.821-.34.181-.272-.031-.438.473-.877.05-.044.184-.337-.216-.417-.084-.019
            0-.353 0-.353-.32.265-.418.637-.935.396-.263-.12-.434
            0-.542.055a.234.234 0 0 1
            .167-.282c.563-.184.717-.408.669-.524a.814.814 0 0
            1-.084-.3c.004-.116.282-.578.692-.734zm1.835
            9.855c-.268.23-.397.275-.339.164.042-.095.077-.193.105-.293.005-.047.226.118.226.118zm-.118-.463zm.075-.42a.548.548
            0 0 0 .016-.105c0-.022.514.455.54.475a2.008 2.008 0 0
            1-.283.314c-.094-.085-.309-.222-.347-.263a2.18 2.18 0 0 0
            .074-.42zm-.08.41.005.01c-.004-.005-.006-.008-.005-.01zm1.87.75c-.808.78-2.017.498-2.97.915-.865.307-1.49
            1.088-2.396 1.285-.266.082-.31.215-.14.21.1 0 .651.56
            1.535.126.294-.145 1.21-.644 1.366-.672-.496.462-.745.874-1.189
            1.124-.27.142-1.376.529-2.478.32-.488-.093-.864.347-.74.337.262-.068.554-.033.73.187.321.25.784.555
            1.183.1.133-.15.765-.472 1.36.118-.633-.032-.57 1.08-1.768.949-.448
            0-1.421-.995-1.704-.685-.496.541 1.065 1.058.392
            1.742-.618.617-1.34-.49-1.34-.49.38.156
            1.093.256.773-.348-.122-.24-.356-.457-.356-.898-.053-.221-1.45
            1.757-2.373.863-.362-.351-1.098-1.12-1.769-1.415 1.769-.146
            2.037.546 2.121.653.565.744 1.09-.011
            1.206-.143.183-.205.443-.486.351-.528-.58-.269-1.103-.31-1.732-.28-.1
            0-.263.017-.263.017.062-.091.136-.174.221-.245.785-.603 1.597-.18
            1.678-.1 0 0-.033-.49-1.01-.61-.766-.097-1.441.576-1.974.576-.433
            0-1.745-.867-2.053-1.633.763.559 1.726 1.068 2.333.714 1.14-.665
            2.592.149
            2.658.029-.324-.245-1.046-1.197-3.005-.653-.778.217-1.08-.316-1.547-.326.794-.689
            1.344-.339 1.622-.318.066
            0-.27-.514-.549-.515-2.272-.01-3.607-.62-3.607-.62s.36-.364
            1.12-.134c0 0-.768-.49-.76-1.125.026-.399.156-.835-.154-1.164
            1.254-.05.365 1.662 1.244
            2.103.022.008-.24-.216.152-.536.184.503.615.567.93.648a.173.173 0 0
            0 .153-.03.14.14 0 0 0
            .013-.162c-.178-.288-.219-.572-.251-.906a3.917 3.917 0 0
            1-.016-.932l.007-.007c.077 0
            .183.206.267.383.096.203.14.452.214.708.063.25.177.484.335.69.202.251.327.503.508.624a.849.849
            0 0 0
            .094-.408c-.041-.288-.313-.792.196-1.242.24.672.61.616.654.937.06.451
            0 .269.046.62.046.34.312.472.705.777.888.473 1.533.67 1.922
            1.273.124-.685-1.024-1.064-1.738-1.789-.354-.359-.62-.75-.527-1.408.042-.322.075-.597-.082-.888a.928.928
            0 0 0-.285-.347c.383.011.636.306.903.598.36.416.605.918.708
            1.455.114.608.585.667 1.105
            1.46.05.018-.33-.629-.272-1.79.027-.466.111-.926.251-1.372.07-.225.164-.442.282-.648.054.174.094.35.12.53.039.298.046.598.021.898a3.44
            3.44 0 0
            0-.01.496c.019.18.089.422.1.54.021.245-.049-.87.805-1.443.053.42.394
            1.08 0 1.779-.474.843-.596.517-.446
            1.567-.005-.043.285-.661.61-1.055.688-.84.078-1.344.752-2.073.05.364.148.22.188.544.09.728-.687
            1.525-.516
            1.499.199-.026.516-.194.625-.746.038.101.066.207.081.315a.401.401 0
            0 1-.101.351c-.085.08-.166.155-.243.239a.802.802 0 0
            0-.21.767c.234-.274.648-.49.813-.821.103-.207.12-.554.084-.796.043-.382.441-.465.52-1.352.015-.147.106-.348.251-.427-.065.499.251
            1.061-.199 1.667.103.054.428-.44.981-.244-1.112.196-.774 1.326-1.63
            1.876-.258.164-.214.351-.291.376.764-.046 1.55-.739
            1.656-.805.802-.508 1.006-.801
            1.22-1.623.058-.224.084-.376.146-.557.035-.097.125-.197.258-.327a.934.934
            0 0 1
            .064.361c.004.43-.215.84-.264.98-.113.284-.27.544-.467.778-.048.054-.03.096
            0 .082 2.101-.785 2.106-1.469 2.599-2.105.148-.245.81-.68
            1.083-.72-.067.132-.352.356-.365.597-.025.446-.172.716-.402
            1.073.128.155.374-.293.625-.068-.334.108-.48.47-.739.682zm.387-.07a4.215
            4.215 0 0 1-.69
            1.631c-.251.358-.356-.339-.138-1.012.326-.134.612-.349.828-.623zM11.381.768c-.263-.036-.449-.326-.686-.407-.327-.12-.69.24-.69.275
            0 .086.097.13.361-.034a.288.288 0 0 0 .028.428.924.924 0 0
            1-.287-.082c-.016.081.121.183.178.22.176.07.339.092.473.02.21-.104.391-.353.623-.397zm-.74.234s.117-.123.116-.21a.308.308
            0 0 0-.115-.208c.146.057.286.128.418.212zm-7.923
            9.75c.203.135.446.196.666.288.276.703.007 1.395-.147
            1.107-.272-.501-.378-.92-.52-1.396"></path>
        </svg>
        <a
          href="https://www.uchicago.edu"
          target="_blank"
          rel="noopener noreferrer">
          <span class="show-for-large">THE UNIVERSITY OF CHICAGO</span>
          <span class="hide-for-large">UCHICAGO</span>
        </a>
      </div>
      <nav class="utility-menu">
        <ul id="menu-utility-menu" class="menu">
          <li
            id="menu-item-249"
            class="email-updates menu-item menu-item-type-custom
            menu-item-object-custom menu-item-249">
            <a
              target="_blank"
              rel="noopener"
              href="https://uchicago.us9.list-manage.com/subscribe?u=655d81e60f4e0d2c3959628d6&amp;id=6cf0dd6740">
              Get E-mail Updates
            </a>
          </li>
          <li
            id="menu-item-250"
            class="menu-item menu-item-type-custom menu-item-object-custom
            menu-item-250">
            <a
              target="_blank"
              rel="noopener"
              href="https://twitter.com/impact_lab">
              Follow Us
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <div class="site-header__primary">
    <div class="container">
      <div class="site-branding">
        <a href="https://climateimpactlab.justdev.co/">

          <img
            width="87"
            height="25"
            src="https://climateimpactlab.justdev.co/wp-content/uploads/2024/05/CIL-Logo.svg"
            class="attachment-full size-full"
            alt="
            "
            decoding="async" />
        </a>
      </div>
      <nav class="primary-menu" class:is-visible="{menuVisible}">
        <ul id="menu-primary" class="menu">
          <li
            id="menu-item-2716"
            class="menu-item menu-item-type-post_type menu-item-object-page
            menu-item-has-children menu-item-2716">
            <a href="https://climateimpactlab.justdev.co/about/">About</a>
            <button class="submenu-toggle" aria-label="Toggle Sub Menu">

              <svg
                height="20"
                width="9"
                class="icon caret-right"
                aria-hidden="true"
                role="img">
                <title id="title-caret-right-34502">caret-right</title>

                <use xlink:href="#caret-right"></use>

              </svg>

            </button>

            <ul class="sub-menu">
              <li
                id="menu-item-2721"
                class="menu-item menu-item-type-post_type menu-item-object-page
                menu-item-2721">
                <a href="https://climateimpactlab.justdev.co/our-approach/">
                  Our Approach
                </a>
              </li>
              <li
                id="menu-item-2720"
                class="menu-item menu-item-type-post_type menu-item-object-page
                menu-item-2720">
                <a href="https://climateimpactlab.justdev.co/team/">Our Team</a>
              </li>
              <li
                id="menu-item-2719"
                class="menu-item menu-item-type-post_type menu-item-object-page
                menu-item-2719">
                <a
                  href="https://climateimpactlab.justdev.co/partners-founders/">
                  Partners &amp; Founders
                </a>
              </li>
              <li
                id="menu-item-2718"
                class="menu-item menu-item-type-post_type menu-item-object-page
                menu-item-2718">
                <a
                  href="https://climateimpactlab.justdev.co/about/opportunities/">
                  Opportunities
                </a>
              </li>
              <li
                id="menu-item-2717"
                class="menu-item menu-item-type-post_type menu-item-object-page
                menu-item-2717">
                <a href="https://climateimpactlab.justdev.co/about/contact/">
                  Contact
                </a>
              </li>
            </ul>
          </li>
          <li
            id="menu-item-2722"
            class="menu-item menu-item-type-post_type menu-item-object-page
            menu-item-2722">
            <a href="https://climateimpactlab.justdev.co/areas-of-focus/">
              Areas of Focus
            </a>
          </li>
          <li
            id="menu-item-2723"
            class="menu-item menu-item-type-post_type menu-item-object-page
            menu-item-2723">
            <a href="https://climateimpactlab.justdev.co/map/">Impact Map</a>
          </li>
          <li
            id="menu-item-2724"
            class="menu-item menu-item-type-post_type menu-item-object-page
            menu-item-2724">
            <a href="https://climateimpactlab.justdev.co/research/">Research</a>
          </li>
          <li
            id="menu-item-2727"
            class="menu-item menu-item-type-post_type menu-item-object-page
            menu-item-2727">
            <a href="https://climateimpactlab.justdev.co/lab-impacts/">
              Lab Impacts
            </a>
          </li>
          <li
            id="menu-item-2725"
            class="menu-item menu-item-type-post_type menu-item-object-page
            menu-item-2725">
            <a href="https://climateimpactlab.justdev.co/news-insights/">
              News &amp; Insights
            </a>
          </li>

        </ul>
      </nav>
      <button
        class="menu-toggle"
        class:is-active="{menuVisible}"
        aria-label="Toggle Menu"
        on:click="{() => (menuVisible = !menuVisible)}">
        <span class="line line-1"></span>
        <span class="line line-2"></span>
        <span class="line line-3"></span>
      </button>
    </div>
  </div>
</header>

<style>
  header {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    --top-bar-height: 38px;
    --site-gutter: 20px;
    --section-padding-top: 80px;
    --section-padding-bottom: 80px;
    --header-height: 108px;
    --white: #fff;
    --white-rgb: 255, 255, 255;
    --black: #000;
    --black-rgb: 0, 0, 0;
    --rich-black: #000d24;
    --rich-black-rgb: 0, 13, 36;
    --maroon: #800000;
    --navy: #163259;
    --lt-blue: #ebf7f9;
    --evergeen: #006151;
    --purple: #451f59;
    --lt-grey: #d1d3d4;
    --tundora: #4a4a4a;
    --boulder: #767676;
    --gold: #ffa521;
    --terracotta: #de7c01;
    --lt-yellow: #fff6e8;
    --cinnabar: #db3c1c;
    --cyan: #3db1c8;
    --blue: #00718e;
    --orient: #026b8a;
    --teal: #00c7a6;
    --lavender: #c37ee6;
    --border: #cacaca;
    --swiper-theme-color: #007aff;
    --wp--preset--color--black: #000000;
    --wp--preset--color--cyan-bluish-gray: #abb8c3;
    --wp--preset--color--white: #ffffff;
    --wp--preset--color--pale-pink: #f78da7;
    --wp--preset--color--vivid-red: #cf2e2e;
    --wp--preset--color--luminous-vivid-orange: #ff6900;
    --wp--preset--color--luminous-vivid-amber: #fcb900;
    --wp--preset--color--light-green-cyan: #7bdcb5;
    --wp--preset--color--vivid-green-cyan: #00d084;
    --wp--preset--color--pale-cyan-blue: #8ed1fc;
    --wp--preset--color--vivid-cyan-blue: #0693e3;
    --wp--preset--color--vivid-purple: #9b51e0;
    --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple: linear-gradient(
      135deg,
      rgba(6, 147, 227, 1) 0%,
      rgb(155, 81, 224) 100%
    );
    --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan: linear-gradient(
      135deg,
      rgb(122, 220, 180) 0%,
      rgb(0, 208, 130) 100%
    );
    --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange: linear-gradient(
      135deg,
      rgba(252, 185, 0, 1) 0%,
      rgba(255, 105, 0, 1) 100%
    );
    --wp--preset--gradient--luminous-vivid-orange-to-vivid-red: linear-gradient(
      135deg,
      rgba(255, 105, 0, 1) 0%,
      rgb(207, 46, 46) 100%
    );
    --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray: linear-gradient(
      135deg,
      rgb(238, 238, 238) 0%,
      rgb(169, 184, 195) 100%
    );
    --wp--preset--gradient--cool-to-warm-spectrum: linear-gradient(
      135deg,
      rgb(74, 234, 220) 0%,
      rgb(151, 120, 209) 20%,
      rgb(207, 42, 186) 40%,
      rgb(238, 44, 130) 60%,
      rgb(251, 105, 98) 80%,
      rgb(254, 248, 76) 100%
    );
    --wp--preset--gradient--blush-light-purple: linear-gradient(
      135deg,
      rgb(255, 206, 236) 0%,
      rgb(152, 150, 240) 100%
    );
    --wp--preset--gradient--blush-bordeaux: linear-gradient(
      135deg,
      rgb(254, 205, 165) 0%,
      rgb(254, 45, 45) 50%,
      rgb(107, 0, 62) 100%
    );
    --wp--preset--gradient--luminous-dusk: linear-gradient(
      135deg,
      rgb(255, 203, 112) 0%,
      rgb(199, 81, 192) 50%,
      rgb(65, 88, 208) 100%
    );
    --wp--preset--gradient--pale-ocean: linear-gradient(
      135deg,
      rgb(255, 245, 203) 0%,
      rgb(182, 227, 212) 50%,
      rgb(51, 167, 181) 100%
    );
    --wp--preset--gradient--electric-grass: linear-gradient(
      135deg,
      rgb(202, 248, 128) 0%,
      rgb(113, 206, 126) 100%
    );
    --wp--preset--gradient--midnight: linear-gradient(
      135deg,
      rgb(2, 3, 129) 0%,
      rgb(40, 116, 252) 100%
    );
    --wp--preset--font-size--small: 13px;
    --wp--preset--font-size--medium: 20px;
    --wp--preset--font-size--large: 36px;
    --wp--preset--font-size--x-large: 42px;
    --wp--preset--spacing--20: 0.44rem;
    --wp--preset--spacing--30: 0.67rem;
    --wp--preset--spacing--40: 1rem;
    --wp--preset--spacing--50: 1.5rem;
    --wp--preset--spacing--60: 2.25rem;
    --wp--preset--spacing--70: 3.38rem;
    --wp--preset--spacing--80: 5.06rem;
    --wp--preset--shadow--natural: 6px 6px 9px rgba(0, 0, 0, 0.2);
    --wp--preset--shadow--deep: 12px 12px 50px rgba(0, 0, 0, 0.4);
    --wp--preset--shadow--sharp: 6px 6px 0px rgba(0, 0, 0, 0.2);
    --wp--preset--shadow--outlined: 6px 6px 0px -3px rgba(255, 255, 255, 1),
      6px 6px rgba(0, 0, 0, 1);
    --wp--preset--shadow--crisp: 6px 6px 0px rgba(0, 0, 0, 1);
    font-family: "HCo Gotham Narrow SSm", sans-serif;
    font-style: normal;
    font-weight: 400;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    word-wrap: break-word;
    --submenu-offset: 29px;
    background: var(--white);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.18);
    position: sticky;
    top: 0;
    z-index: 20;
    transition: transform 200ms linear;
    will-change: transform;
  }

  .site-header .container {
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
  }

  .branding-bar {
    background: var(--rich-black);
    border-bottom: 1px solid var(--maroon);
    color: var(--white);
    font-size: 12px;
    height: var(--top-bar-height);
    padding: 10px 0;
    top: 0;
    width: 100%;
    z-index: 1;
  }

  .branding-bar .container {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  .branding-bar .uchicago-logo {
    align-items: center;
    display: flex;
    gap: 6px;
  }

  .branding-bar.is-hidden {
    display: none;
  }

  .branding-bar a {
    /* stylelint-disable-line */
    font-style: normal;
    font-weight: 700; /* stylelint-disable-line */
    color: var(--white);
    letter-spacing: -0.25px;
    line-height: 1;
    opacity: 0.8;
    text-decoration: none;
    text-transform: uppercase;
  }

  .branding-bar .utility-menu .menu {
    display: flex;
    gap: 18px;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .branding-bar .utility-menu .menu-item {
    font-size: 12px;
  }

  .site-header {
    --submenu-offset: 29px;
    background: var(--white);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.18);
    position: sticky;
    top: 0;
    z-index: 20;
  }

  .site-header__primary {
    align-items: center;
    display: flex;
    height: var(--header-height);
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .site-header__primary .container {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
  @media (min-width: 1070px) {
    .site-header__primary .container {
      align-items: end;
    }
  }

  .site-header .site-branding img {
    width: 146px;
  }
  @media (min-width: 1070px) {
    .site-header .site-branding img {
      width: 225px;
    }
  }

  .site-header .primary-menu {
    opacity: 0;
    transition: visibility 0s linear 300ms, opacity 300ms;
    visibility: hidden;
    background-color: var(--rich-black);
    height: calc(100dvh - var(--top-bar-height) - var(--header-height));
    left: 0;
    padding: 30px 20px;
    pointer-events: none;
    position: fixed;
    top: calc(var(--top-bar-height) + var(--header-height));
    width: 100%;
  }
  @media (min-width: 1070px) {
    .site-header .primary-menu {
      opacity: 1;
      transition: visibility 0s linear 0s, opacity 300ms;
      visibility: visible;
      background-color: transparent;
      height: auto;
      padding-bottom: 8px;
      pointer-events: auto;
      position: relative;
      top: 0;
      width: auto;
    }
  }

  .site-header .primary-menu.is-visible {
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 300ms;
    visibility: visible;
    pointer-events: auto;
  }

  .site-header .primary-menu .menu {
    column-gap: 25px;
    display: flex;
    flex-direction: column;
    height: 100%;
    list-style-type: none;
    margin: 0;
    overflow-y: auto;
    padding: 0;
    padding-bottom: 30px;
  }
  @media (min-width: 1070px) {
    .site-header .primary-menu .menu {
      flex-direction: row;
      height: auto;
      overflow: visible;
      padding-bottom: 0;
    }
  }

  .site-header .primary-menu .menu-item {
    align-items: center;
    display: grid;
    grid-template-areas: "menu toggle" "submenu submenu";
    position: relative;
  }
  @media (min-width: 1070px) {
    .site-header .primary-menu .menu-item {
      display: block;
    }
  }

  .site-header .primary-menu .menu-item + .menu-item {
    margin-top: 20px;
  }
  @media (min-width: 1070px) {
    .site-header .primary-menu .menu-item + .menu-item {
      margin-top: 0;
    }
  }

  .site-header .primary-menu .menu-item a,
  .site-header .primary-menu .menu-item > button:not(.submenu-toggle) {
    /* stylelint-disable-line */
    font-style: normal;
    font-weight: 400; /* stylelint-disable-line */
    color: var(--white);
    font-size: 15px;
    line-height: 1.2;
    min-height: 30px;
    position: relative;
    text-decoration: none;
  }
  @media (min-width: 1070px) {
    .site-header .primary-menu .menu-item a,
    .site-header .primary-menu .menu-item > button:not(.submenu-toggle) {
      color: var(--black);
      display: inline-block;
      font-size: 16px;
      min-height: unset;
    }
  }

  @media (min-width: 1070px) {
    .site-header .primary-menu .menu-item a::after {
      background-color: var(--gold);
      border-radius: 3px;
      bottom: -5px;
      content: "";
      display: block;
      height: 3px;
      opacity: 0;
      position: absolute;
      transition: opacity 250ms;
      width: 100%;
    }
  }

  .site-header .primary-menu .menu-item a:hover::after,
  .site-header .primary-menu .menu-item.current-menu-item a::after,
  .site-header .primary-menu .menu-item a:focus-within::after {
    opacity: 1;
  }

  @media (min-width: 1070px) {
    .site-header .primary-menu .menu-item.menu-item-has-children > a::before {
      opacity: 0;
      transition: visibility 0s linear 300ms, opacity 300ms;
      visibility: hidden;
      border-color: transparent transparent var(--rich-black) transparent;
      border-style: solid;
      border-width: 0 12px 9px 12px;
      bottom: calc(var(--submenu-offset) * -1 - 3px);
      content: "";
      display: block;
      height: 0;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      width: 0;
    }
  }

  @media (min-width: 1070px) {
    .site-header
      .primary-menu
      .menu-item.menu-item-has-children:hover
      a::before,
    .site-header
      .primary-menu
      .menu-item.menu-item-has-children:focus-within
      a::before {
      opacity: 1;
      transition: visibility 0s linear 0s, opacity 300ms;
      visibility: visible;
    }
  }

  .site-header .primary-menu .submenu-toggle {
    align-items: center;
    background: none;
    border: 0;
    color: #9c9c9c;
    cursor: pointer;
    display: flex;
    height: 30px;
    justify-content: center;
    justify-self: end;
    position: relative;
    transform: rotate(270deg);
    transition: transform 150ms;
    width: 30px;
    z-index: 10;
  }
  @media (min-width: 1070px) {
    .site-header .primary-menu .submenu-toggle {
      display: none;
    }
  }

  .site-header .primary-menu .submenu-toggle.is-active {
    transform: rotate(90deg);
  }

  @media (min-width: 1070px) {
    .site-header .primary-menu .sub-menu::before,
    .site-header .search-form::before {
      background-color: transparent;
      content: "";
      display: block;
      height: var(--submenu-offset);
      left: 0;
      position: absolute;
      top: calc(var(--submenu-offset) * -1);
      width: 100%;
    }
  }

  .site-header .primary-menu .menu-item > .btn-search-toggle {
    display: none;
  }
  @media (min-width: 1070px) {
    .site-header .primary-menu .menu-item > .btn-search-toggle {
      background: none;
      border: none;
      display: block;
      margin: 0;
      padding: 0;
    }
  }

  .site-header .primary-menu .sub-menu {
    /* stylelint-disable-line */
    font-style: normal;
    font-weight: 500; /* stylelint-disable-line */
    color: var(--white);
    display: none;
    font-size: 16px;
    line-height: 1.5;
    list-style-type: none;
    min-width: 260px;
    padding: 10px 0 0 10px;
  }
  @media (min-width: 1070px) {
    .site-header .primary-menu .sub-menu {
      opacity: 0;
      transition: visibility 0s linear 300ms, opacity 300ms;
      visibility: hidden;
      background: var(--rich-black);
      border-radius: 2px;
      display: block;
      font-size: 16px;
      line-height: 1.5;
      margin: var(--submenu-offset) 0 0 -40px;
      padding: 36px 40px;
      position: absolute;
    }
  }

  @media (min-width: 1070px) {
    .site-header .primary-menu .menu-item:hover .sub-menu,
    .site-header .primary-menu .menu-item:focus-within .sub-menu,
    .site-header .primary-menu .menu-item:hover .search-form,
    .site-header .primary-menu .menu-item:focus-within .search-form {
      opacity: 1;
      transition: visibility 0s linear 0s, opacity 300ms;
      visibility: visible;
    }
  }

  .site-header .primary-menu .sub-menu .menu-item + .menu-item {
    margin-top: 18px;
  }

  .site-header .primary-menu .sub-menu a {
    color: #9c9c9c;
  }
  @media (min-width: 1070px) {
    .site-header .primary-menu .sub-menu a {
      color: inherit;
    }
  }

  .site-header .primary-menu .sub-menu a::before {
    content: none;
    display: none;
  }

  .site-header .primary-menu .sub-menu a::after {
    background-color: transparent;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHg9IjAiIHk9IjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2LjMgMTE7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxNi4zIDExIiBmaWxsPSIjREU3QzAxIj48cGF0aCBmaWxsPSIjREU3QzAxIiBkPSJNMTYgNC45IDExLjIuM2MtLjQtLjQtMS0uNC0xLjQgMC0uNC40LS40IDEgMCAxLjRsMi45IDIuOEgxYy0uNiAwLTEgLjQtMSAxcy40IDEgMSAxaDExLjhMOS43IDkuM2MtLjQuNC0uNCAxLS4xIDEuNC4yLjIuNS4zLjcuMy4yIDAgLjUtLjEuNy0uM2w1LTQuNGMuMi0uMi4zLS40LjMtLjdzLS4xLS41LS4zLS43eiIgLz48L3N2Zz4K);
    background-repeat: no-repeat;
    border-radius: 0;
    bottom: 0;
    content: "";
    display: inline-block;
    height: 9px;
    margin-left: 12px;
    margin-top: 0;
    opacity: 0;
    position: relative;
    transition: opacity 150ms;
    width: 15px;
  }

  .site-header .primary-menu .sub-menu a:hover::after,
  .site-header .primary-menu .sub-menu a:focus-within::after {
    opacity: 1;
  }

  .site-header .primary-menu .sub-menu .current-menu-item a {
    color: var(--terracotta);
  }

  .site-header .menu-item .search-form {
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 300ms;
    visibility: visible;
    background-color: var(--black);
    left: 0;
    padding: 25px 16px 25px 20px;
    position: fixed;
    top: calc(100dvh - 80px);
    width: 100%;
  }
  @media (min-width: 1070px) {
    .site-header .menu-item .search-form {
      opacity: 0;
      transition: visibility 0s linear 300ms, opacity 300ms;
      visibility: hidden;
      background: var(--rich-black);
      border-radius: 2px;
      left: auto;
      margin-top: var(--submenu-offset);
      padding: 25px 26px 25px 30px;
      position: absolute;
      right: 0;
      top: auto;
      width: 700px;
    }
  }

  .site-header .menu-item .search-form__label {
    color: var(--white);
    display: none;
  }
  @media (min-width: 1070px) {
    .site-header .menu-item .search-form__label {
      display: block;
    }
  }

  .site-header .menu-item .search-form__input {
    color: var(--white);
  }
  .site-header .menu-item .search-form__input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: var(--white);
  }
  .site-header .menu-item .search-form__input::-moz-placeholder {
    /* Firefox 19+ */
    color: var(--white);
  }
  .site-header .menu-item .search-form__input:-ms-input-placeholder {
    /* IE 10+ */
    color: var(--white);
  }
  .site-header .menu-item .search-form__input:-moz-placeholder {
    /* Firefox 18- */
    color: var(--white);
  }

  @media (min-width: 1070px) {
    .site-header .menu-toggle {
      display: none;
    }
  }

  .menu-toggle {
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: block;
    flex: 0 0 auto;
    height: 1em;
    margin-top: -3px;
    padding: 0;
    position: relative;
    width: 30px;
  }

  .menu-toggle .line {
    background: #9c9c9c;
    border-radius: 1px;
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    transition: all 0.4s;
    width: 30px;
  }

  .menu-toggle .line-1 {
    top: 0;
  }

  .menu-toggle .line-2 {
    top: 50%;
  }

  .menu-toggle .line-3 {
    top: 100%;
  }

  .menu-toggle.is-active .line-1 {
    transform: translateY(0.5em) translateX(0) rotate(45deg) !important ;
  }

  .menu-toggle.is-active .line-2 {
    opacity: 0 !important ;
  }

  .menu-toggle.is-active .line-3 {
    transform: translateY(-0.5em) translateX(0) rotate(-45deg) !important ;
  }

  .headroom {
    transition: transform 200ms linear;
    will-change: transform;
  }

  .headroom--pinned {
    transform: translateY(0%);
  }

  .headroom--unpinned {
    transform: translateY(-100%);
  }

  .hide-for-large {
    display: none;
  }

  img {
    height: auto;
    max-width: 100%;
  }
  @media only screen and (max-width: 1070px) {
    header {
      --header-height: 70px;
    }
    .show-for-large {
      display: none;
    }

    .hide-for-large {
      display: block;
    }
  }
</style>
